import { formatDate } from '@root/helpers';
import type { CellContext, ColumnHelper } from '@tanstack/react-table';

export const createdAtAccessor = <T extends { created_at?: string }>(columnHelper: ColumnHelper<T>) =>
  columnHelper.accessor((row) => row.created_at, {
    id: 'created_at',
    header: 'Created at',
    enableColumnFilter: false,
    size: 168,
    minSize: 168,
    maxSize: 168,
    cell: (cellContext: CellContext<T, string>) =>
      formatDate(cellContext.row.original.created_at ?? '', 'DD MMM YYYY HH:mm'),
    sortingFn: 'datetime',
    sortUndefined: -1,
  });
